export const filterAllEmployees = 'ALL';
export const filterEmployeesWithNoLogin = 'NO_LOGIN';
